<template>
  <div class="container">
    <div class="action-part">
      <el-form :inline="true" size="medium">
        <el-form-item>
          <el-button type="primary" @click="showEditor(null)">创建套餐</el-button>
        </el-form-item>
        <el-form-item>
          <el-input v-model="search.name" placeholder="请输入套餐名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="doSearch">查 询</el-button>
          <el-button type="info" @click="doSearchCancel">重 置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="content-list">
      <el-table
          border
          :data="resultList"
          style="width: 100%">
        <el-table-column
            width="200"
            align="center"
            label="封面">
<!--          <template slot-scope="scope">-->
<!--            <img :src="scope.row.background" style="border-radius:5px;width: 63px;height: 83px;"  alt="image"/>-->
<!--          </template>-->
          <template v-slot="scope">
            <el-image style="width: 100px; height: 100px" :src="scope.row.background" fit="cover" v-if="scope.row.background"></el-image>
            <div v-else>暂无图片</div>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            prop="name"
            label="套餐名称"
            width="250">
        </el-table-column>
        <el-table-column
            header-align="center"
            width="250"
            label="价格">
          <template v-slot="scope">
            <span>{{scope.row.price}} ({{scope.row.priceType === '1' ? '绿色石头' : scope.row.priceType === '2' ? '蓝色石头' : '红色石头'}})</span>
          </template>
        </el-table-column>
        <el-table-column
            min-width="200"
            prop="description"
            label="简介"
            class-name="description-cell"
        >
          <template v-slot="scope">
            <div class="description-container">
              <el-tooltip :content="scope.row.description" placement="top">
                <span>{{ extractPlainTextFromHtml(scope.row.description) }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            prop="createTime"
            width="180"
            label="创建时间">
        </el-table-column>
        <el-table-column
            align="center"
            width="300"
            label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="medium" @click="showEditor(scope.row)">编辑</el-button>
            <el-popconfirm
                confirm-button-text='马上删除'
                cancel-button-text='我后悔了'
                icon="el-icon-info"
                @confirm="deleteItem(scope.row.id)"
                icon-color="red"
                title="确定删除该套餐吗？">
              <el-button slot="reference" type="danger" style="margin-left: 10px;" size="medium">
                删除
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page-part">
      <el-pagination
          size="small"
          background
          @current-change="loadByPage"
          :page-size="pagination.pageSize"
          :current-page="pagination.currentPage"
          layout="prev, pager, next"
          :total="pagination.total">
      </el-pagination>
    </div>
    <div class="dialog-part">
      <el-dialog
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :title="editorTitle"
          :visible.sync="isEditorShow"
          width="80vw"
          center>
        <div class="dialog-content">
          <el-form  :model="resourcePackage" ref="resourcePackage" :rules="resourcePackageRules" label-width="120px" size="medium">
            <el-form-item prop="name" label="名称">
              <el-input v-model="resourcePackage.name"></el-input>
            </el-form-item>
            <el-form-item prop="description" label="简介">
              <tinymce-editor v-model='resourcePackage.description' @input='contentChange' />
            </el-form-item>
            <el-form-item prop="background" label="封面">
              <div class="form-item-container">
                <div class="image-upload-cover" @click="showImageCut">
                  <img v-if="resourcePackage.background" :src="resourcePackage.background" class="avatar" alt="image" />
                  <span v-else style="font-size: 30px">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </span>
                </div>
              </div>
              <div class="form-des-text">
                支持JPEG/PNG，大小不超过5M，尺寸大小为：1260x1660
              </div>
            </el-form-item>
            <el-form-item prop="price" label="石头数量">
              <el-input-number v-model="resourcePackage.price" :min="1"></el-input-number>
              <el-select v-model="resourcePackage.priceType" placeholder="请选择石头类型" style="margin-left: 10px">
                <el-option :label="`绿色石头`" :value="`1`"> </el-option>
                <el-option :label="`蓝色石头`" :value="`2`"> </el-option>
                <el-option :label="`红色石头`" :value="`3`"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="periodValidity" label="有效期">
              <template #label>
                有效期
                <el-tooltip content="如果是0则表示永久有效" placement="top">
                  <el-icon class="el-icon-warning"></el-icon>
                </el-tooltip>
              </template>
              <el-input-number v-model="resourcePackage.periodValidity" :min="0"></el-input-number>
              <el-select v-model="resourcePackage.periodValidityUnits" placeholder="请选择有效期单位" style="margin-left: 10px">
                <!--
                有效期单位：0-日；1-月；2-季度；3-年;
                 -->
                <el-option :label="`日`" :value="`0`"> </el-option>
                <el-option :label="`月`" :value="`1`"> </el-option>
                <el-option :label="`季度`" :value="`2`"> </el-option>
                <el-option :label="`年`" :value="`3`"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="sorted" label="排序">
              <el-input-number v-model="resourcePackage.sorted" :min="0"></el-input-number>
            </el-form-item>
          </el-form>

          <div class="table-info">
            <h3 style="margin-bottom: 20px">资源列表</h3>
            <el-table
                ref="resourceRef"
                height="400px"
                border
                :data="resourceList"
                style="width: 100%"
                @selection-change="handleResourceSelectionChange"
            >
              <el-table-column
                  type="selection"
                  width="60"
              >
              </el-table-column>
              <el-table-column
                  prop="name"
                  align="center"
                  label="名称">
              </el-table-column>
              <el-table-column
                  width="200"
                  align="center"
                  label="资源类别">
                <template v-slot="scope">
                  <el-tag type="danger" v-if="scope.row.type === 'preCategory'">睡前故事分类</el-tag>
                  <el-tag type="success" v-if="scope.row.type === 'book'">书本</el-tag>
                  <el-tag type="warn" v-if="scope.row.type === 'reading'">读本</el-tag>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
           <el-button @click="onEditorCancel">取 消</el-button>
           <el-button type="primary" @click="onEditorConfirm">确 定</el-button>
        </span>
      </el-dialog>

      <my-upload
          ref="imageUpload"
          field="image"
          @crop-upload-success="cropUploadSuccess"
          v-model="isCutShow"
          :withCredentials="true"
          :noCircle="true"
          :url="imageUploadUrl"
          img-format="jpg"></my-upload>
    </div>
  </div>
</template>

<script>
import * as api from "@/api/api";
import myUpload from "vue-image-crop-upload";
import tinymceEditor from '@/component/editor.vue'

export default {
  components: {myUpload, tinymceEditor},
  data() {
    return {
      content: '',
      descriptionLineClamp: 2,
      search: {
        name: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
        totalPage: 1
      },
      resultList: [],
      resourcePackage: {
        id: '',
        periodValidity: 0,
        periodValidityUnits: "0",
        price: 1,
        priceType: '1',
        sorted: 999,
        resourcePackageMappingList: []
      },
      /** 资源对象信息 */
      resourceList: [],
      editorTitle: '新增套餐包',
      isEditorShow: false,
      isCutShow: false,
      /** 上传图片地址 */
      imageUploadUrl: '',
      resourcePackageRules: {
        name: [
          { required: true, message: '请输入套餐包名称', trigger: 'blur' },
          { min: 2, message: '长度在2个字符以上', trigger: 'blur' }
        ],
        description: [
            { required: true, message: '请输入套餐包描述', trigger: 'blur' }
        ],
        background: [
            { required: true, message: '请上传套餐包背景图', trigger: 'change' }
        ],
        price: [
            { required: true, message: '请输入套餐包价格', trigger: 'blur' }
        ],
        priceType: [
            { required: true, message: '请选择套餐包价格类型', trigger: 'blur' }
        ],
        periodValidity: [
            { required: true, message: '请输入套餐包有效期', trigger: 'blur' }
        ],
        periodValidityUnits: [
            { required: true, message: '请选择套餐包有效期单位', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    extractPlainTextFromHtml(html) {
      // 创建一个 DOM 元素用于解析 HTML
      const div = document.createElement('div');
      div.innerHTML = html;

      // 移除所有 img 标签
      div.querySelectorAll('img').forEach(img => img.remove());

      // 获取所有段落内容
      const paragraphs = Array.from(div.querySelectorAll('p'));

      // 提取段落中的纯文本
      const plainText = paragraphs
        .map(p => p.textContent.trim())
        .filter(text => text !== '') // 去除空段落
        .join('\n'); // 你可以换成其它连接符，如空格

      return plainText;
    },
    contentChange(data) {
      this.content = data
    },
    deleteItem(id) {
      api.resourcePackageDelete(id).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.$message.success(result.msg);
          this.listContent();
        } else {
          this.$message.error(result.msg);
        }
      })
    },

    doSearch() {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = 20;
      this.listContent();
    },
    doSearchCancel() {
      this.search.name = '';
      this.doSearch();
    },
    loadByPage(page) {
      this.pagination.currentPage = page;
      this.listContent();
    },
    getResourceList() {
      api.getResourceList().then(result => {
        if (result.code === api.SUCCESS_CODE) {
          const resultData = result.data;

          // 提取需要合并的三个数据类型
          const { preCategory, book, reading } = resultData;

          // 合并并添加 type 字段
          // 对象类别：1-睡前故事；2-教材；3-阅读读本；4-识字；5-拼音；6-数学；
          this.resourceList = [
            // 为 preCategory 添加 type: 'preCategory'
            ...preCategory.map(item => ({...item, type: 'preCategory'})),

            // 为 book 添加 type: 'book'
            ...book.map(item => ({...item, type: 'book'})),

            // 为 reading 添加 type: 'reading'
            ...reading.map(item => ({...item, type: 'reading'}))
          ];
        }
      })

    },

    listContent() {
      api.resourcePackagePage(this.pagination.currentPage, this.pagination.pageSize, this.search.name).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          let data = result.data;
          this.resultList = data.list;
          this.pagination.currentPage = data.currentPage;
          this.pagination.pageSize = data.pageSize;
          this.pagination.total = data.total;
          this.pagination.totalPage = data.totalPage;
        }
      })
    },
    showImageCut() {
      this.isCutShow = true;
      const token = this.$store.state.user.token;
      this.imageUploadUrl = `${api.baseUrl}/md/image/resource-package?ct-sob-admin-token=${token}`;

    },
    onEditorCancel() {
      this.resourcePackage = {
        id: '',
        periodValidity: 0,
        periodValidityUnits: "0",
        background: '',
        price: 1,
        priceType: '1',
        sorted: 999,
        resourcePackageMappingList: []
      }
      this.isEditorShow = false;
      this.$refs.resourceRef.clearSelection();
    },
    showEditor(item) {
      this.resourcePackage = {
        id: '',
        periodValidity: 0,
        periodValidityUnits: "0",
        background: '',
        price: 1,
        priceType: '1',
        sorted: 999,
        resourcePackageMappingList: []
      }

      if (item) {
        api.resourcePackageDetail(item.id).then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.resourcePackage = result.data;
            // 回显的资源列表
            console.log('result.data.resourcePackageMappingList', result.data.resourcePackageMappingList)

            // 在 showEditor 方法中补充以下逻辑：
            // 1. 获取已关联的资源ID列表
            const selectedResourceIds = result.data.resourcePackageMappingList.map(item => item.objectId);

            // 2. 遍历资源列表设置选中状态
            this.$refs.resourceRef.clearSelection(); // 先清除原有选择
            this.resourceList.forEach((resource, index) => {
              if (selectedResourceIds.includes(resource.id)) {
                this.$refs.resourceRef.toggleRowSelection(this.resourceList[index], true);
              }
            });
          }
        })
        this.editorTitle = '编辑套餐';
      } else {
        this.editorTitle = '创建套餐';
      }
      this.isEditorShow = true;
    },
    onEditorConfirm() {
      if (!this.resourcePackage.resourcePackageMappingList || this.resourcePackage.resourcePackageMappingList.length === 0) {
        this.$message({
          message: '请选择资源',
          type: 'warning'
        });
        return;
      }
      this.$refs.resourcePackage.validate((valid) => {
        if (!valid) {
          // this.$message({
          //   message: '请填写完整信息',
          //   type: 'warning'
          // });
          return false;
        }


        if (this.resourcePackage.id !== '') {
          api.resourcePackageUpdate(this.resourcePackage.id, this.resourcePackage).then(result => {
            if (result.code === api.SUCCESS_CODE) {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              // 重新获取列表数据
              this.listContent()
              // 关闭编辑窗口
              this.isEditorShow = false;
              this.$refs.resourcePackage.resetFields();
              this.$refs.resourceRef.clearSelection();
              this.resourcePackage.resourcePackageMappingList = []
            }else {
              this.$message.error(result.msg);
            }
          })
        }else {
          api.resourcePackageSave(this.resourcePackage).then(result => {
            if (result.code === api.SUCCESS_CODE) {
              this.$message({
                message: '保存成功',
                type: 'success'
              });
              // 重新获取列表数据
              this.listContent()
              // 关闭编辑窗口
              this.isEditorShow = false;
              this.$refs.resourcePackage.resetFields();
              this.$refs.resourceRef.clearSelection();
              this.resourcePackage.resourcePackageMappingList = []
            }else {
              this.$message.error(result.msg);
            }
          })
        }
      })
    },
    cropUploadSuccess(result) {
      if (result.code === api.SUCCESS_CODE) {
        this.resourcePackage.background = result.data;
        // 手动触发background字段的校验
        this.$nextTick(() => { // 确保DOM更新后触发校验
          this.$refs.resourcePackage.validateField('background');
        });
      }
    },
    handleResourceSelectionChange(val) {
      this.resourcePackage.resourcePackageMappingList = val.map(item => {
        return {
          objectId: item.id,
          type: item.type === 'preCategory' ? '1' : item.type === 'book' ? '2' : '3'
        }
      })
    }
  },
  mounted() {
    this.listContent();
    this.getResourceList();
  }
}
</script>

<style scoped>
/* 穿透 el-table 的 cell 容器 */
.description-cell ::v-deep .cell {
  padding: 0 !important;
  position: relative; /* 确保定位上下文 */
}

/* 直接作用于内容容器 */
.description-container {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  word-break: break-all;
  line-height: 20px;
  max-height: 40px;
  white-space: normal !important;
}

/* 悬停提示样式 */
.description-container:hover {
  cursor: help;
}
</style>

